import type { AddressBook } from '@integrations/address-books/contracts/address-book.contract';

import { inject } from '@angular/core';
import type { CreateQueryOptions } from '@tanstack/angular-query-experimental';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { AddressBooksApiService } from '../api/address-books-api.service';

export const ADDRESS_BOOKS_QUERY_KEY = ['address-books', 'active'] as const;

type AddressBooksQueryOverrides = Partial<Omit<CreateQueryOptions<AddressBook[]>, 'queryKey' | 'queryFn'>>;

export function injectAddressBooksQuery(optionsFn?: () => AddressBooksQueryOverrides) {
    const api = inject(AddressBooksApiService);

    return injectQuery(() => ({
        staleTime: 5 * 60 * 1000, // 5 minutes
        queryKey: ADDRESS_BOOKS_QUERY_KEY,
        queryFn: () => lastValueFrom(api.getActiveAddressBooks()),
        ...optionsFn?.(),
    }));
}
